import { render, staticRenderFns } from "./categoryCalibration.vue?vue&type=template&id=d8477bbc&"
import script from "./categoryCalibration.vue?vue&type=script&lang=js&"
export * from "./categoryCalibration.vue?vue&type=script&lang=js&"
import style0 from "./categoryCalibration.vue?vue&type=style&index=0&id=d8477bbc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports